import Vue from 'vue';

var XpProgressBar = Vue.extend({
  name: 'XpProgressBar',
  props: {
    color: {
      type: String
    },
    height: {
      type: String,
      default: '5px'
    },
    value: {
      type: Number,
      default: null
    }
  },
  computed: {
    ariaLoading: function ariaLoading() {
      if (this.value === 0) {
        return this.$t('global.loading', ['']);
      }

      return this.$t('global.loading', ["".concat(this.value, "%")]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.shouldNotifyLoadingToSr = true;
    }, 1000);
  },
  render: function render(h) {
    return h('div', {
      class: 'c-xp-progress-bar',
      style: {
        height: this.height,
        color: this.color
      }
    }, [h('div', {
      attrs: {
        'aria-hidden': true
      },
      class: 'c-xp-progress-bar__line'
    }), h('div', {
      attrs: {
        'aria-hidden': true
      },
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--inc'
    }), h('div', {
      attrs: {
        'aria-hidden': true
      },
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--dec'
    }), h('div', {
      attrs: {
        'aria-hidden': true
      },
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--actual',
      style: "width: ".concat(this.value, "%")
    }), h('div', {
      class: 'sr-only'
    }, this.ariaLoading)]);
  }
});

export { XpProgressBar as X };
//# sourceMappingURL=XpProgressBar.js.map
